import * as React from "react";
const XCorp = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M13.303 10.771 19.123 4h-1.38L12.69 9.88 8.655 4H4l6.103 8.89L4 19.993h1.38l5.335-6.21 4.262 6.21h4.655l-6.33-9.22h.001Zm-1.889 2.198-.618-.885-4.92-7.045h2.118l3.97 5.686.619.885 5.16 7.39h-2.117l-4.212-6.03Z" }));
XCorp.displayName = "XCorp";
var XCorp_default = XCorp;
export {
  XCorp_default as default
};
